import { type FC, type JSX, type ReactNode } from 'react'
import { FormattedMessage } from 'react-intl'

import { NumberedListItem } from 'base-ui'

const accentuate = (text: ReactNode[]): JSX.Element => (
  <span className="inline font-medium italic text-dark-brand">{text}</span>
)

export const RxLpComHowToRedeemInfoPoints: FC = () => (
  <ol className="flex flex-col gap-6 self-start">
    <NumberedListItem>
      <div className="flex flex-1 flex-col gap-2">
        <span className="text-s">
          <FormattedMessage id="rx.com.redeem.item.1.title" />
        </span>
        <span className="text-s text-dark-primary-strong">
          <FormattedMessage
            id="rx.com.redeem.item.1.description"
            values={{
              accentuate,
            }}
          />
        </span>
      </div>
    </NumberedListItem>
    <NumberedListItem>
      <div className="flex flex-1 flex-col gap-2">
        <span className="text-s">
          <FormattedMessage id="rx.com.redeem.item.2.title" />
        </span>
        <span className="text-s text-dark-primary-strong">
          <FormattedMessage
            id="rx.com.redeem.item.2.description"
            values={{
              accentuate,
            }}
          />
        </span>
      </div>
    </NumberedListItem>
    <NumberedListItem>
      <div className="flex flex-1 flex-col gap-2">
        <span className="text-s">
          <FormattedMessage id="rx.com.redeem.item.3.title" />
        </span>
        <span className="text-s text-dark-primary-strong">
          <FormattedMessage
            id="rx.com.redeem.item.3.description"
            values={{
              accentuate,
            }}
          />
        </span>
      </div>
    </NumberedListItem>
  </ol>
)
